<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <!-- Feeds-->
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <v-layout class="px-5 pb-8" justify-center align-center>
                  <v-text-field
                    class="mr-3"
                    :disabled="loadingSearch"
                    v-model="searchTextModel"
                    :label="$t('labels.searchAcademy')"
                    v-on:keyup.enter="searchText"
                    hide-details
                    outlined
                    rounded
                  >
                    <template v-slot:append>
                      <v-btn
                        text
                        :loading="loadingSearch"
                        :disabled="searchTextModel.length < 3"
                        color="defaultColor"
                        @click="searchText"
                        class="text-capitalize"
                        style="margin-top: -7px"
                      >
                        {{ $t("buttons.search") }}
                      </v-btn>
                    </template>
                  </v-text-field>

                  <academy-filter-button @filterData="(n) => filterData(n)" />
                </v-layout>

                <v-divider class="mb-4" />

                <v-layout class="px-4" justify-center align-center>
                  <!-- <v-subheader
                    v-if="selectedCategoryName"
                    class="defaultColor--text font-weight-bold"
                    v-text="selectedCategoryName"
                  ></v-subheader> -->
                  <v-chip
                    v-if="selectedCategoryName"
                    class="ma-2"
                    close
                    color="defaultColorLight"
                    outlined
                    @click:close="clearCategoryFilter"
                  >
                    {{ selectedCategoryName }}
                  </v-chip>
                  <v-spacer />
                  <v-subheader
                    class="defaultColor--text"
                    v-text="$t('title.totalCount', { count: this.totalCount })"
                  ></v-subheader>
                </v-layout>

                <v-layout class="mt-0 pt-0" v-if="data.length > 0">
                  <v-list
                    three-line
                    subheader
                    two-line
                    class="pa-5"
                    style="background-color: transparent !important"
                  >
                    <template v-for="(item, index) in data">
                      <v-divider></v-divider>

                      <v-list-item @click="gotoPostdetail(item.Id)">
                        <v-list-item-avatar tile size="60" class="rounded">
                          <v-img
                            :src="getThumbnailUrl(item)"
                            v-if="getItemType(item) == 'video'"
                          >
                            <v-layout
                              justify-center
                              align-center
                              fill-height
                              class="ma-0 pa-0"
                            >
                              <v-icon color="white" size="40">mdi-play</v-icon>
                            </v-layout>
                          </v-img>

                          <pdf-thumbline
                            v-if="getItemType(item) == 'document'"
                            :width="60"
                            :height="60"
                            :thumbnailURL="getThumbnailUrl(item)"
                          />
                        </v-list-item-avatar>

                        <v-list-item-content class="defaultColor--text">
                          <v-list-item-title
                            class="font-weight-bold"
                            v-html="item.Title"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="defaultColor--text"
                            v-html="item.Content"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <div
                      class="text-center"
                      v-if="data.length > 0 && !moreButtonHidden"
                    >
                      <v-btn
                        text
                        color="defaultColorLight"
                        @click="loadMore()"
                        :loading="moreButtonLoading"
                        class="text-capitalize mt-2"
                      >
                        {{ $t("buttons.more") }}
                      </v-btn>
                    </div>
                  </v-list>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import AcademyFilterButton from "../../components/Academy/AcademyFilterButton.vue";
import PostService from "../../services/PostService";
import PdfThumbline from "../../components/Academy/PdfThumbline.vue";
export default {
  data: function () {
    {
      return {
        data: [],

        searchTextModel: "",

        page: 1,
        pageSize: 15,

        moreButtonHidden: false,
        moreButtonLoading: false,

        items: [
          { header: "Today" },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            title: "Brunch this weekend?",
            subtitle: `<span class="text--primary">Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          },
          { divider: true, inset: true },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
            title:
              'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
            subtitle: `<span class="text--primary">to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.`,
          },
          { divider: true, inset: true },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
            title: "Oui oui",
            subtitle:
              '<span class="text--primary">Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?',
          },
          { divider: true, inset: true },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
            title: "Birthday gift",
            subtitle:
              '<span class="text--primary">Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?',
          },
          { divider: true, inset: true },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
          {
            avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
            title: "Recipe to try",
            subtitle:
              '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          },
        ],

        sortKey: 3,
        dateFilter: "",
        categoryIds: "",
        totalCount: 0,
        loadingSearch: false,
        selectedCategoryName: "",
      };
    }
  },
  components: {
    LoadingProgress,
    AcademyFilterButton,
    PdfThumbline,
  },
  methods: {
    searchText() {
      this.getPosts();
    },

    getPosts() {
      this.loadingSearch = true;
      this.moreButtonLoading = true;
      PostService.getAcademySearch(
        this.page,
        this.pageSize,
        this.searchTextModel,
        this.sortKey,
        this.dateFilter,
        this.categoryIds
      )
        .then((res) => {
          this.totalCount = res.data.TotalData;
          let resData = res.data.Data;
          if (this.page !== 1) {
            this.data = [...this.data, ...resData];
          } else {
            this.data = resData;
          }
          if (resData.length <= 0 || resData.length < this.pageSize || true) {
            this.moreButtonHidden = true;
          }
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.loadingSearch = false;
          this.moreButtonLoading = false;
        });
    },

    filterData(item) {
      console.log("item :", item);
      this.sortKey = item.sort;
      this.dateFilter = item.created;
      this.categoryIds = item.category;
      this.selectedCategoryName = item.categoryName;
      this.page = 1;
      this.getPosts();
    },

    loadMore() {
      this.page++;
      this.getPosts();
    },

    getItemType(item) {
      if (item.Files.length > 0) {
        if (
          item.Files[0].FileExtension === ".mp4" ||
          item.Files[0].FileExtension === ".mov" ||
          item.Files[0].FileExtension === ".MP4" ||
          item.Files[0].FileExtension === ".MOV"
        ) {
          return "video";
        } else {
          return "document";
        }
      } else {
        return "document";
      }
    },

    clearCategoryFilter() {
      this.categoryIds = "";
      this.selectedCategoryName = "";

      (this.sortKey = ""), (this.dateFilter = ""), this.getPosts();
    },
  },
  computed: {
    getThumbnailUrl() {
      return (item) => {
        if (!item.Files || item.Files.length === 0) {
          return require("../../../public/images/pdf.png").default;
        }

        if (this.getItemType(item) === "video") {
          return item.Files[0].ThumbnailUrl
            ? item.Files[0].ThumbnailUrl
            : require("../../../public/images/ThumbVideo.png").default;
        }

        return item.Files[0].ThumbnailUrl
          ? item.Files[0].ThumbnailUrl
          : require("../../../public/images/pdf.png").default;
      };
    },
  },
  destroyed() {},
  mounted() {
    //Anasayfadan arama yapılıp gelindiyse
    if (this.$route.query.searchText) {
      this.searchTextModel = this.$route.query.searchText;
      this.getPosts();
    } else if (this.$route.query.Id) {
      //Anasayfadan kategori seçilip gelindiyse
      this.categoryIds = this.$route.query.Id;
      this.selectedCategoryName = this.$route.query.Name;
      this.getPosts();
    }
  },
  watch: {},
};
</script>
